// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".NewTable__body__lazy-load-element{height:1px}", "",{"version":3,"sources":["webpack://./src/main/js/common/components/new-table/components/table-view/components/body/body.styles.scss"],"names":[],"mappings":"AACE,mCACE,UAAA","sourcesContent":[".NewTable__body {\n  &__lazy-load-element {\n    height: 1px;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
